import React, { Component } from 'react'
import PropTypes from "prop-types";
import BarChart from './barmb'
import { connect } from 'react-redux'
import typo from '../../../constants/dictionaries'
import Select from "../../../components/Common/Select";
import Button from "../../../components/Buttons";
import { Icon, Row } from "antd";
import Helper from '../../../helper/helper';
class BoxChartBM extends Component {
    constructor(props) {
        super(props);
        this.state = {
            years: [],
            tunam: new Date().getFullYear() - 15,
            dennam: new Date().getFullYear()

        }
    }
    componentDidMount() {
        this.getYears()
    }
    getYears = () => {
        var c_year = new Date().getFullYear(); var years = []
        for (var i = c_year; i >= 1990; i--) { years.push({ year: i }) }
        this.setState({ years: years })
    }
    downFilePDF = () => {
        const input = document.getElementById('chart-to-export-pdf-bieudo-cot');
        Helper.exportPdf(input, 'landscape', "BieuDo.pdf")
    }
    render() {
        const { data, functions, history, thongke } = this.props
        const { years, tunam, dennam } = this.state
        return (
            <div className='box-chart'>
                <div className='box-chart-title'>{this.props.title}</div>
                <div style={{ marginLeft: "15px", height: "70px" }}>
                    <Row type="flex">
                    <Select
                        dataSource={years}
                        value={tunam}
                        onChange={(value) => this.setState({ tunam: value })}
                        placeholder={typo.cscore_tunam}
                        label={typo.cscore_tunam}
                        width="100px"
                        mandatory={false}
                        name="year"
                        name_value="year"
                        className='button-add'
                    />
                    <Select
                        dataSource={years}
                        value={dennam}
                        onChange={(value) => this.setState({ dennam: value })}
                        placeholder={typo.cscore_dennam}
                        label={typo.cscore_dennam}
                        width="100px"
                        mandatory={false}
                        name="year"
                        name_value="year"
                        className='button-add'
                    />
                    </Row>
                    <Row type="flex" style={{paddingBottom:"100px"}} >
                        <Button
                            type="submit"
                            className='button-add'
                            style={{ marginTop: 25 }}
                            onClick={() => { thongke(tunam, dennam) }}>
                            <Icon type="bar-chart" style={{ marginLeft: '0px' }} />Thống kê</Button>
                    
                        <Button
                            type="pdf"
                            className='button-add'
                            style={{ marginTop: 25 }}
                            onClick={() => { this.downFilePDF() }}>
                            <Icon type="file-pdf" style={{ marginLeft: '0px' }} />Xuất file PDF</Button>
                    </Row>
                </div>
                <div className='box-chart-content' style={{paddingTop:25}} id='chart-to-export-pdf-bieudo-cot' >{data && <BarChart data={data} hiddenLegends={false} history={history} functions={functions} />}</div>
            </div>
        )
    }
}
BoxChartBM.propTypes = {
    thongke: PropTypes.func.isRequired,
};
const mapPropsToState = (state) => ({
    user: state.oidc.user,
    functions: state.functions
});
export default connect(mapPropsToState)(BoxChartBM)